import { useMutation, useQuery } from "@tanstack/react-query"
import {
  archiveThread,
  createMessage,
  deleteThread,
  listMessages,
  listRenderOptions,
  listThreads,
  updateThread,
} from "@/lib/http/chat"
import { ChatResponse } from "@/types/api"

export const useListThreads = () =>
  useQuery({
    queryKey: ["threads"],
    queryFn: () => listThreads(),
  })

export const useListMessages = (threadId: string, options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: ["messages/", threadId],
    queryFn: () => listMessages(threadId),
    enabled: options?.enabled !== false && !!threadId,
  })

export const useUpdateThread = (options: {
  onSuccess?: (data: void) => void
  onError?: (error: any) => void
  onSettled?: () => void
}) =>
  useMutation({
    mutationFn: ({ threadId, data }: { threadId: string; data: { name: string } }) => updateThread(threadId, data),
    onSuccess: options.onSuccess,
    onSettled: options.onSettled,
    onError: options.onError,
  })

export const useArchiveThread = (options: {
  onSuccess?: (data: void) => void
  onError?: (error: any) => void
  onSettled?: () => void
}) =>
  useMutation({
    mutationFn: (threadId: string) => archiveThread(threadId),
    onSuccess: options.onSuccess,
    onSettled: options.onSettled,
    onError: options.onError,
  })

export const useDeleteThread = (options: {
  onSuccess?: (data: void) => void
  onError?: (error: any) => void
  onSettled?: () => void
}) =>
  useMutation({
    mutationFn: (threadId: string) => deleteThread(threadId),
    onSuccess: options.onSuccess,
    onSettled: options.onSettled,
    onError: options.onError,
  })

export const useCreateMessage = (options: {
  onSuccess?: (data: ChatResponse) => void
  onError?: (error: any) => void
  onSettled?: () => void
}) =>
  useMutation({
    mutationFn: (data: { content: string; resource_id: string; thread_id?: string }) => createMessage(data),
    onSuccess: options.onSuccess,
    onSettled: options.onSettled,
    onError: options.onError,
  })

export const useListRenderOptions = () =>
  useQuery({
    queryKey: ["render-options"],
    queryFn: () => listRenderOptions(),
    staleTime: 30 * 60 * 1000, // 30 minutes
  })
